import { Controller } from "@hotwired/stimulus"
import { Loggable } from "./concerns/loggable"
import { ShowHide }   from "./concerns/showHide";

export default class extends Controller {

  static targets = ["replyForm", "toggleCommentButton"]

  static values = {}

  static outlets = []

  connect() {
    Loggable(this, {debug: false})
    ShowHide(this)
    this.log("connected")
  }

  toggleReply(event){
    event.preventDefault()
    if (this.hasToggleCommentButtonTarget) {
      this.toggle(this.toggleCommentButtonTarget)
    }
    this.toggle(this.replyFormTarget)
    const expanded = !this.isHidden(this.replyFormTarget)
    this.element.querySelectorAll('[data-action="comment#toggleReply"][aria-controls]').forEach(button => {
      if (button.getAttribute("aria-controls") === this.replyFormTarget.id) {
        button.setAttribute("aria-expanded", String(expanded))
      }
    })
    if (expanded) {
      const textarea = Array.from(this.replyFormTarget.querySelectorAll("textarea"))
        .find(field => field.closest('[data-controller~="comment"]') === this.element)
      textarea?.focus()
    }
  }

}
